var map = {
	"./Dentist1.png": 2813,
	"./Dentist2.png": 8838,
	"./Dentist3.png": 5775,
	"./Dentist4.png": 4448,
	"./Doctor1.png": 7945,
	"./dietitian.png": 8664,
	"./doctor2.png": 5746,
	"./doctor3.png": 9403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2060;